import { useEffect } from 'react'
import type { CashLocale } from '@tenant/shared-ui'
import './dashboardDemo.css'

export const CASH_DASHBOARD_DEMO_PATH = '/dashboard-demo'

/** A separate, synthetic design page. No Cash client or session is provided. */
export function CashDashboardDemoPage() {
  useEffect(() => {
    const previous = document.title
    document.title = 'PF · Демо | Kassa'
    return () => { document.title = previous }
  }, [])

  return (
    <main className="cash-demo-page">
      <header className="cash-demo-bar">
        <p><strong>Демо</strong><span>Вымышленные данные · Cash не подключён</span></p>
        <a href="/">В Кассу</a>
      </header>
      <iframe
        className="cash-demo-frame"
        src="/demo/pf-dashboard.html"
        title="Дашборд PF — демонстрационные данные"
        sandbox="allow-scripts"
        referrerPolicy="no-referrer"
      />
    </main>
  )
}

export function CashDashboardDemoLink({ locale }: { locale: CashLocale }) {
  const label = { ru: 'Дашборд · демо', az: 'Panel · demo', en: 'Dashboard · demo' }[locale]
  return <a className="app-demo-link" href={CASH_DASHBOARD_DEMO_PATH} target="_blank" rel="noopener noreferrer">{label}</a>
}
